<template>
    <div class="header">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'LiFaHeader',
}
</script>
<style lang="scss" scoped>

</style>

